import {
    UPDATE_SALES_WALKTHROUGH_REQUEST,
    UPDATE_SALES_WALKTHROUGH_SUCCESS,
    UPDATE_SALES_WALKTHROUGH_FAILURE,
} from "../../../../Constants/actionTypes";

const initialState = {
    updating: false,
    updateError: null,
};

const salesWalkthroughReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SALES_WALKTHROUGH_REQUEST:
            return {
                ...state,
                updating: true,
                updateError: null,
            };

        case UPDATE_SALES_WALKTHROUGH_SUCCESS:
            return {
                ...state,
                updating: false,
            };

        case UPDATE_SALES_WALKTHROUGH_FAILURE:
            return {
                ...state,
                updating: false,
                updateError: action.payload,
            };

        default:
            return state;
    }
};

export default salesWalkthroughReducer;
